<template>
  <div>
    <div class="panel">
      <div class="panel-section" v-for="(timer, index) in countdownTimers" :key="index">
        <countdown-timer 
          :start-date-string="timer.NotificationStartDate" 
          :target-date-string="timer.EventStartDate" 
          :header-text="timer.TitleDescription" 
          :footer-text="timer.CTA"
          :target-url="timer.EventUrl && timer.EventUrl.Url ? timer.EventUrl.Url : null"
          :BackgroundImage="timer.BackgroundImage"
          :timer-text-color="timer.TimerTextColor"
          :timer-background-color="timer.TimerBackgroundColor"
          :logo="timer.Logo"
          :footer-color="timer.FooterBackgroundColor"/>
      </div>
      <div class="panel-section">
        <popular-apps />
      </div>
      <div class="panel-section">
        <my-content ref="myContent" />
      </div>
      <div class="panel-section">
        <bookmarks />
      </div>
      <div class="panel-section">
        <events />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PopularApps from "./PopularApps";
import Bookmarks from "./Bookmarks";
import Events from "./events/Events";
import MyContent from "./MyContent";
import CountdownTimer from "./CountdownTimer";
import * as CONSTANTS from "@/store/constants";
import api from "@/api";

export default {
  name: "right-panel",
  components: {
    CountdownTimer, // Register the new component
    Bookmarks,
    PopularApps,
    Events,
    MyContent,
  },
  data() {
    return {
      countdownTimers: [],
    };
  },
  mounted() {
    this.getCountdownTimer();
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    // impersonation
    "user.userName": function () {
      this.$refs.myContent.initializeContent();
    },
  },
  methods: {
    async getCountdownTimer() {
        let response = (await api.getCountdownTimer()).value;
        response = response.filter(item => item.fields.status === 'active').map(item => {
          return {
            ...item.fields,
            BackgroundImage: item.webUrl,
          }
        });
        this.countdownTimers = response;
    },
  },
};
</script>

<style scoped>
.loading-skeleton {
  min-height: 800px;
}
.panel {
  padding-top: 19px;
  padding-left: 2.2rem;
  padding-right: 2.2rem;
  font-family: 'artifaktElementRegular', Arial, sans-serif; /* Apply font globally */
}
.panel-section {
  padding-bottom: 1rem;
  font-family: 'artifaktElementRegular', Arial, sans-serif;
}

.panel-section countdown-timer {
  margin-bottom: 0.2rem; 
}

@media (max-width: 992px) {
  .panel {
    padding-left: 2.0rem;
    padding-right: 2.0rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/RightPanel.vue